
import apiMixin from "../../../mixins/apiMixin";
const BrandKonstrucktorTrademarkCategory = {
    namespaced: true,
    state: {
        result: null,
    },
    mutations: {
        setResult: function (state, payload) {
            state.result = payload;
        },

    },
    actions: {
        getTrademarkCategory: async function (state, payload) {
            return apiMixin.methods.getTrademarkCategory(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    state.commit('setResult', response.data);
                    //console.log(response.data);
                    return true;

                });

        },

    },
    getters: {
        getResult: function (state) {
            return state.result
        }
    }
}
export default BrandKonstrucktorTrademarkCategory